import {
  CUSTOM_WORKFLOW_INFO_DISMISS,
  REMOVE_WORKFLOW_LIST_FILTER,
  FILTER_WORKFLOW_LIST_BY_EDITABLE,
} from 'actions/workflowsPreferences';

export function getInitialWorkflowsState() {
  return {
    customWorkflowInfoDismissed: false,
    isWorkflowListFilteredByEditable: true,
  };
}

function workflowsReducer(state = getInitialWorkflowsState(), action) {
  switch (action.type) {
    case CUSTOM_WORKFLOW_INFO_DISMISS: {
      return { ...state, customWorkflowInfoDismissed: true };
    }
    case REMOVE_WORKFLOW_LIST_FILTER: {
      return { ...state, isWorkflowListFilteredByEditable: false };
    }
    case FILTER_WORKFLOW_LIST_BY_EDITABLE: {
      return { ...state, isWorkflowListFilteredByEditable: true };
    }
    default:
      return state;
  }
}

export default workflowsReducer;
